export default function svgNode() {
  const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
  svg.style.position = 'absolute';
  svg.style.top = '0';
  svg.style.left = '0';
  svg.style.width = '100%';
  svg.style.height = '100%';
  svg.style.pointerEvents = 'none';

  // To debug the SVG size:
  // svg.style.backgroundColor = 'rgba(255,0,0,.3)';

  return svg;
}
